enum EntityType {
  Award = 'Award',
  Comment = 'Comment',
  Community = 'Community',
  Contact = 'Contact',
  Gathering = 'Gathering',
  Group = 'Group',
  OnlineStatus = 'OnlineStatus',
  Photo = 'Photo',
  User = 'User'
}
export default EntityType
